import { useState, useRef, useContext } from "react";

import GlobalContext       from "../../isp._comun/contexto/GlobalContext";
import useHandlerDeComando from '../../isp._comun/componentes/useHandlerDeComando'
import * as TipoDeError    from "../../isp._comun/servicios/Errores";
import ServicioDeLogin     from "../../isp.servicios.idyacceso/ServicioDeLogin";
import PantallaLogin from "./layouts/PantallaLogin";
// import login from "../../servicios/login";
// import * as Evento from "../../../comun/Eventos";
// import { NotificacionToastDeError } from "../../../_comun/componentes/widgets/Notificaciones";
// import CodigoDeError from "../../../_comun/CodigosDeErrorDeRespuestas.json";
// import DataRespuestas from "../../../_comun/DataEstaticaDeRespuestas.json";

const PantallaInteractivaDeLogueo = ({ cargarPantallaPrincipal }) => {
    // const [evaluacion, setEvaluacion] = useState(null);
    const [nombreUsuario, setNombreUsuario] = useState("");
    const [contraseña, setContraseña] = useState("");
    const [loading, setLoading] = useState(false);

    const [banderasError, setBanderasError] = useState({
        usuNoVal: false,
        nomVacio: false,
        contraVacia: false,
    });

    const refPantallaLoguin = useRef(null);
    // const [evaluacion, setEvaluacion] = useState({clienteNoValido:false, usuarioVacio:false, contraseñaVacia:false});
    //console.log("entro presentador logueo?")
    const notificar = function (notificacion) {
        refPantallaLoguin.current.notificar(notificacion);
    };

    // const manejarLogueo = async () => {
    const manejarLogueo = useHandlerDeComando ( async () => {
        setLoading(true);

        try {
            const usuario = await new ServicioDeLogin().ejecutar({
                nombreUsuario,
                contraseña,
            });
            cargarPantallaPrincipal(usuario);
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                const nuevoEstado = JSON.parse(JSON.stringify(banderasError));
                for (const property in nuevoEstado) {
                    nuevoEstado[property] = false;
                }

                error.data.errores.forEach((error) => {
                    nuevoEstado[error.key] = true;
                });

                setLoading(false);
                setBanderasError(nuevoEstado);
                return
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                setLoading(false);
                setBanderasError({
                    usuNoVal: false,
                    nomVacio: false,
                    contraVacia: false,
                    // errorServidor: true,
                });
                throw error;
                /* let nombreDeError = error.constructor.name;
                refPantallaLoguin.current.notificar(
                    new NotificacionToastDeError(
                        DataRespuestas[nombreDeError].titulo,
                        DataRespuestas.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataRespuestas[nombreDeError].descripcion
                    )
                ); */
                
            }
            
        }
    });

    const setearNombreUsuario = (nombreUsuario) => {
        setNombreUsuario(nombreUsuario);
        // setBanderasError({ ...banderasError, usuarioVacio: false });
    };
    const setearContraseña = (contraseña) => {
        setContraseña(contraseña);
        // setBanderasError({ ...banderasError, contraseñaVacia: false });
    };

    const values = useContext(GlobalContext);
    values.notificar = notificar;

    return (
        <PantallaLogin
            nombreUsuario={nombreUsuario}
            contraseña={contraseña}
            loading={loading}
            banderasError={banderasError}
            setearNombreUsuario={setearNombreUsuario}
            setearContraseña={setearContraseña}
            manejarLogueo={useHandlerDeComando(manejarLogueo)}
            ref={refPantallaLoguin}
        />
    );
};

export default PantallaInteractivaDeLogueo;
